module.exports = __webpack_public_path__ + "static/media/litchi.ef9bbeac.png";